(function () {

  // ===== Slider (.ksl) =====
  (function () {
    var track = document.getElementById('kuiSlider');
    if (!track) return;
    var dotsWrap = document.getElementById('kuiSliderDots');
    var slides = Array.from(track.children);

    // ドット生成
    slides.forEach(function (_, i) {
      var d = document.createElement('button');
      d.className = 'ksl-dot' + (i === 0 ? ' active' : '');
      d.setAttribute('aria-label', (i + 1) + '枚目');
      d.addEventListener('click', function () {
        track.scrollTo({ left: slides[i].offsetLeft, behavior: 'smooth' });
      });
      dotsWrap.appendChild(d);
    });

    // ドット更新
    var dots = dotsWrap.querySelectorAll('.ksl-dot');
    track.addEventListener('scroll', function () {
      var closest = 0, min = Infinity;
      slides.forEach(function (s, i) {
        var d = Math.abs(s.offsetLeft - track.scrollLeft);
        if (d < min) { min = d; closest = i; }
      });
      dots.forEach(function (d, i) { d.classList.toggle('active', i === closest); });
    }, { passive: true });

    // ループ：端検知→即座にジャンプ
    track.addEventListener('scrollend', function () {
      var maxScroll = track.scrollWidth - track.clientWidth;
      if (track.scrollLeft >= maxScroll - 4) {
        track.scrollTo({ left: 0, behavior: 'instant' });
      } else if (track.scrollLeft <= 4 && track.scrollLeft !== 0) {
        track.scrollTo({ left: maxScroll, behavior: 'instant' });
      }
    }, { passive: true });
  })();

  // ===== Coupon Copy + Confetti =====
  (function () {
    var btn = document.getElementById('kuiCouponCopy');
    if (!btn) return;
    var colors = ['#e07b00', '#418d44', '#1a2332', '#f0c960', '#fff'];
    btn.addEventListener('click', function () {
      navigator.clipboard.writeText(
        document.getElementById('kuiCouponCode').textContent.trim()
      ).then(function () {
        var msg = document.getElementById('kuiCouponCopied');
        msg.style.display = 'block';
        setTimeout(function () { msg.style.display = 'none'; }, 2500);
      });
      var box = btn.closest('.kui-coupon');
      for (var i = 0; i < 36; i++) {
        var p = document.createElement('span');
        p.className = 'kui-cp';
        var angle = (Math.random() * 360) * (Math.PI / 180);
        var dist = 60 + Math.random() * 80;
        p.style.cssText = [
          '--tx:' + Math.round(Math.cos(angle) * dist) + 'px',
          '--ty:' + Math.round(Math.sin(angle) * dist - 60) + 'px',
          '--tr:' + Math.round(Math.random() * 360) + 'deg',
          '--dur:' + (0.7 + Math.random() * 0.5) + 's',
          '--sz:' + (5 + Math.random() * 5) + 'px',
          '--cl:' + colors[Math.floor(Math.random() * colors.length)],
          '--br:' + (Math.random() > .5 ? '50%' : '2px'),
          'left:' + btn.offsetLeft + 'px',
          'top:' + btn.offsetTop + 'px',
        ].join(';');
        box.appendChild(p);
        setTimeout(function (el) { el.remove(); }, 1400, p);
      }
    });
  })();

  // ===== Length Calculator =====
  (function () {
    var selGround  = document.getElementById('kuiCalcGround');
    var selDepth   = document.getElementById('kuiCalcDepth');
    var selMargin  = document.getElementById('kuiCalcMargin');
    var resultIdle = document.querySelector('.kc-ri');
    var resultAns  = document.getElementById('kuiCalcAnswer');
    var formula    = document.getElementById('kuiCalcFormula');
    var sizeEl     = document.getElementById('kuiCalcSize');
    var ctaEl      = document.getElementById('kuiCalcCta');
    var noteEl     = document.getElementById('kuiCalcNote');
    var sizeTable  = document.getElementById('kuiSizeTable');
    if (!selGround || !selDepth || !selMargin) return;

    // バリアントURLマップ（長さcm → variant ID）
    var variantMap = {
      40:  '44293227872356', 50:  '44293227905124', 60:  '44293227937892',
      70:  '44293227970660', 80:  '44293228003428', 90:  '44293228036196',
      100: '44293228068964', 110: '44293228101732', 120: '44293228134500',
      130: '44293228167268', 140: '44293228200036', 150: '44293228232804',
      160: '44293228265572', 170: '44293228298340', 180: '44293228331108',
      190: '44293228363876', 200: '44293228396644'
    };
    var baseUrl = 'https://kuicks.jp/products/kui318astd';

    function update() {
      var g = parseInt(selGround.value, 10);
      var d = parseInt(selDepth.value,  10);
      var m = parseInt(selMargin.value, 10);
      if (!g || !d || isNaN(m)) {
        resultIdle.hidden = false;
        resultAns.hidden  = true;
        return;
      }
      var total       = g + d + m;
      var recommended = Math.ceil(total / 10) * 10;
      formula.textContent = g + ' + ' + d + ' + ' + m + ' =';
      sizeEl.textContent  = recommended + ' cm';
      resultIdle.hidden = true;
      resultAns.hidden  = false;

      // CTA URL更新
      if (ctaEl) {
        var vid = variantMap[recommended];
        ctaEl.href = vid ? baseUrl + '?variant=' + vid : baseUrl;
      }

      // 注記
      if (noteEl) {
        noteEl.textContent = recommended > 200
          ? '※2m超のサイズはお問い合わせください。'
          : '';
      }

      // テーブルハイライト
      if (sizeTable) {
        sizeTable.querySelectorAll('tr').forEach(function (r) {
          r.classList.remove('calc-highlight');
        });
        var target = sizeTable.querySelector('tr[data-length="' + recommended + '"]');
        if (target) {
          target.classList.add('calc-highlight');
        }
      }
    }

    [selGround, selDepth, selMargin].forEach(function (el) {
      el.addEventListener('change', update);
    });
  })();

})();
